import './style.scss';
import $ from "jquery";
import { gsap } from 'gsap';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

$(document).ready(() => {
    $('.wp-block-keztablocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity({
        pageDots: false,
        prevNextButtons: false,
        groupCells: false,
        contain: true,
        imagesLoaded: true,
        percentPosition: true,
        wrapAround: true,
        autoPlay: 4000,
    });

    $('.wp-block-keztablocks-latest-posts__gallery-button--prev').on( 'click', function() {
        $('.wp-block-keztablocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity('previous');
    });

    $('.wp-block-keztablocks-latest-posts__gallery-button--next').on( 'click', function() {
        $('.wp-block-keztablocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity('next');
    });
});